import {
	FETCH_INFORMATIONS_BEGIN,
	FETCH_INFORMATIONS_SUCCESS,
	FETCH_INFORMATIONS_ERROR,
} from "../actions/informationActions"

const initialState = {
	informations: [],
	fetchInformations: {
		loading: false,
		error: false,
	},
}

export default function informationReducer(state = initialState, action) {
	switch (action.type) {
		case FETCH_INFORMATIONS_BEGIN:
			return {
				...state,
				fetchInformations: { loading: true, error: false },
			}
		case FETCH_INFORMATIONS_SUCCESS:
			return {
				...state,
				// append : page suivante (« Charger plus ») — on concatène en
				// dédupliquant par id (un poll a pu déjà ramener l'élément).
				informations: action.payload.append
					? [
							...state.informations,
							...action.payload.informations.filter(
								(i) =>
									!state.informations.some(
										(s) => s.id === i.id,
									),
							),
						]
					: action.payload.informations,
				fetchInformations: { loading: false, error: false },
			}
		case FETCH_INFORMATIONS_ERROR:
			return {
				...state,
				fetchInformations: { loading: false, error: action.payload },
			}
		default:
			return state
	}
}
